document.addEventListener('DOMContentLoaded', () => {
  const productMediaSlider = Array.from(document.querySelectorAll(".product-media-slider"));
  console.log(productMediaSlider);
  const flickitySlides = [];
  function changeThumbnail(thumbnailImg, parentElement) {
    const thumbnailList = parentElement.querySelector(".carousel-thumbnail__list");
    const containerWidth = thumbnailList.clientWidth;
    const thumbnailWidth = thumbnailImg.clientWidth;
    const thumbnailLeft = thumbnailImg.offsetLeft;
  
    const scrollTo = thumbnailLeft - (containerWidth / 2) + (thumbnailWidth / 2);
    thumbnailList.scrollTo({
      left: scrollTo,
      behavior: 'smooth'
    });
  }

  productMediaSlider.forEach((element) => {
    // 260708 CONSUL-2551 既存コード --------------------
    const carousel = element.querySelector(".carousel");
    // 260708 CONSUL-2551 スライド数の表示を追加（carouselStatus）
    const carouselStatus = element.querySelector(".carousel-status");
    const productThumbnails = Array.from(element.getElementsByClassName("carousel-thumbnail__list-item"));
    var flickity = new Flickity(carousel, {
      cellAlign: 'left',
      cellSelector: '.carousel-item',
      accessibility: false,
      prevNextButtons: true,
      pageDots: false,
      resize: false,
      adaptiveHeight: true,
      selectedAttraction: 1,
      friction: 1,
      draggable: false
    });
    flickitySlides.push(flickity);

    function updateStatus() {
      const slideNumber = flickity.selectedIndex + 1;
      if (carouselStatus) {
        carouselStatus.textContent = slideNumber + '/' + flickity.slides.length;
      }
    }
    updateStatus();

    flickity.on('select', function () {
      productThumbnails.forEach(element => {
        element.classList.remove("is-selected");
      });
      productThumbnails[flickity.selectedIndex].classList.add("is-selected");
      changeThumbnail(productThumbnails[flickity.selectedIndex], element);
      flickity.slides.forEach(slide => {
        slide.target = slide.x;
      });
      flickity.settle();
      updateStatus();
    });

    for (let i = 0; i < productThumbnails.length; i++) {
      productThumbnails[i].addEventListener('click', () => {
        productThumbnails.forEach(element => {
          element.classList.remove("is-selected");
        });
        productThumbnails[i].classList.add("is-selected");
    
        changeThumbnail(productThumbnails[i], element);
    
        flickity.select(i);
      })
    }

    let startX = 0;

    // スワイプ開始時の処理
    carousel.addEventListener('pointerdown', (event) => {
      startX = event.pageX;
    });

    // スワイプ終了時の処理
    carousel.addEventListener('pointerup', (event) => {
        const endX = event.pageX;
        const distance = endX - startX;
        if (distance < -50) {
          // 右にスワイプ
          flickity.next();
        } else if (distance > 50) {
          // 左にスワイプ
          flickity.previous();
        }
    });

      flickity.resize();
      const thumbnailImg = element.querySelector(".carousel-thumbnail__list-item.is-selected");
      changeThumbnail(thumbnailImg, element);

    // 260708 CONSUL-2551 追加コード --------------------
    const modalCarousel = element.querySelector(".modal-carousel");
    const modalCarouselOpenButtons = element.querySelectorAll(".modal-carousel-open");
    const modalCarouselCloseButtons = element.querySelectorAll(".modal-carousel-close");

    // Swiperインスタンスを作成（zoom有効）
    const modalSwiper = new Swiper(modalCarousel, {
      zoom: true,
      slidesPerView: 1,
      navigation: {
        nextEl: '.modal-carousel-next',
        prevEl: '.modal-carousel-prev',
      },
      on: {
        slideChange: () => {
          const mediaIndex = modalSwiper.realIndex + 1;
          flickity.select(mediaIndex - 1);
        },
      },
    });

    modalCarouselOpenButtons.forEach(modalCarouselOpenButton => {
      modalCarouselOpenButton.addEventListener('click', () => {
        const mediaIndex = modalCarouselOpenButton.getAttribute('data-media-index');
        modalCarousel.classList.add('is-open');
        modalSwiper.slideTo(mediaIndex - 1, 0); // speedを0に設定してアニメーションなしで遷移
      });
    });

    modalCarouselCloseButtons.forEach(modalCarouselCloseButton => {
      modalCarouselCloseButton.addEventListener('click', () => {
        modalCarousel.classList.remove('is-open');
        modalCarousel.classList.add('is-closing');
        // Use animationend event instead of setTimeout for more reliable animation control
        const onAnimationEnd = () => {
          modalCarousel.classList.remove('is-closing');
          modalCarousel.removeEventListener('animationend', onAnimationEnd);
        };
        modalCarousel.addEventListener('animationend', onAnimationEnd);
      });
    });

  });

  window.addEventListener('resize', () => {
    productMediaSlider.forEach((element, index) => {
      flickitySlides[index].resize();

      const thumbnailImg = element.querySelector(".carousel-thumbnail__list-item.is-selected");
      changeThumbnail(thumbnailImg, element);
    });
  });
});
